export default __webpack_public_path__ + "images/getting-started.png";